import AdresseSummary from '@/generated/controls/adresse/AdresseSummary.vue';
import Adresse from '@/extend/classes/Adresse';
import Owner from '@/extend/classes/Owner';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: AdresseSummary,
    methods: {
        getDisplay(adresse: Adresse): string {
            return adresse.ville + ' (' + adresse.codePostal + '), ' + adresse.adresse1;
        },
        setAttribut(adresse: Adresse, owner: Owner, parentObj: unknown): void {
            if (owner) {
              adresse.owner = owner;
            }
        }
    }
})
